const constants = {
    // API URL
    // serverUrl: 'http://localhost:3025',
    serverUrl: 'https://api.katiadoodletoys.ru',
    SIZE_MULTIPLIER: 0.2,
    SPEED_RANGE: 2,
    BASE_OPACITY: 0.6,
    HOVER_SCALE: 1.2,
    TRANSITION_SPEED: 0.3,
    PAGE_TRANSITION: {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: { duration: 0.3, ease: "easeInOut" }
    },
    CATEGORIES: ['Doodle Toys', 'Открытки', 'Постеры', 'Кубики', 'Магниты'],
    TOYS_TYPES: ['Собаки и кошки', 'Персонажи', 'Всадники', 'Звери', 'Птицы', 'Букашки', 'Пары', '3D', 'Разные'],
    CARDS_TYPES: ['10х15 100 р.', '15х20 150 р.', 'Doodle Toys', 'Рисунки', 'Узоры', 'Разные'],
    SORT_TYPES: [
        {sortType: 'newest', name: 'Самые новые'},
        {sortType: 'biger', name: 'Покрупнее'},
        {sortType: 'smaller', name: 'Поменьше'},
        {sortType: 'cheaper', name: 'Дешевле'},
        {sortType: 'expensive', name: 'Дороже'},
    ],
    TG_USER_NAME: 'katiashumok',
    MAIL_TO: 'shumok-shumok@yandex.ru'

}

export default constants